import React from 'react';
import SkillCategory from './SkillCategory';

const SkillsGrid = ({ skillsData }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      {skillsData.map((category, index) => (
        <SkillCategory
          key={index}
          icon={category.icon}
          title={category.title}
          skills={category.skills}
        />
      ))}
    </div>
  );
};

export default SkillsGrid;